import { render, staticRenderFns } from "./new-task-card.vue?vue&type=template&id=4b03c0f6&scoped=true&"
import script from "./new-task-card.vue?vue&type=script&lang=js&"
export * from "./new-task-card.vue?vue&type=script&lang=js&"
import style0 from "./new-task-card.vue?vue&type=style&index=0&id=4b03c0f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03c0f6",
  null
  
)

export default component.exports